import { Activity, Archive, CheckCircle, FilePlus, Trash, Book, Clock, Shield, Lock, FileText } from 'react-feather';

export const TodoCategoriesList = [
  {
    title: 'Tüm İşler',
    icon: <Book size={20}/>,
    color: 'primary',
  },
  {
    title: 'Yeni Eklenenler',
    icon: <FilePlus size={20}/>,
    color: 'danger',
  },
  {
    title: 'Yapılacaklar',
    icon: <Clock size={20}/>,
    color: 'warning',
  },
  {
    title: 'Devam Edenler',
    icon: <Activity size={20}/>,
    color: 'info',
  },
  {
    title: 'Tamamlananlar',
    icon: <CheckCircle size={20}/>,
    color: 'success',
  },
  {
    title: 'Çalışılmayanlar',
    icon: <Trash size={20}/>,
    color: 'dark',
  },
  {
    title: 'Tahkime Hazırlar',
    icon: <Shield size={20}/>,
    color: 'warning',
  },
  {
    title: 'Tahkimdekiler',
    icon: <Activity size={20}/>,
    color: 'info',
  },
  {
    title: 'İcradakiler',
    icon: <FileText size={20}/>,
    color: 'primary',
  },
  {
    title: 'Kapak Bekleyenler',
    icon: <Archive size={20}/>,
    color: 'success',
  },
  {
    title: 'Kapalı Dosyalar',
    icon: <Lock size={20}/>,
    color: 'danger',
  },
];